// ============================================================================
// DEPARTURE SERVICE (PMS phase 1)
// ============================================================================

import { get, post } from '../client/axiosClient';
import { departureEndpoints } from '../endpoints/departure.endpoints';
import type { ApiResponse, ID } from '../types';
import type { DeparturePreview, DepartRoomsRequest, StayChargePreview } from '../types/departure.types';

class DepartureService {
  async getPreview(bookingId: ID): Promise<DeparturePreview> {
    const response = await get<ApiResponse<DeparturePreview>>(
      departureEndpoints.preview(bookingId),
    );
    if (!response.data?.data) {
      throw new Error(response.data?.message || 'Failed to load room list.');
    }
    return response.data.data;
  }

  async previewStayCharges(bookingId: ID, payload: { checkInRoomIds: ID[]; departureDate: string; departureTime: string }): Promise<StayChargePreview> {
    const response = await post<ApiResponse<StayChargePreview>>(departureEndpoints.stayChargesPreview(bookingId), payload);
    if (!response.data?.data) throw new Error(response.data?.message || 'Could not work out the stay charges.');
    return response.data.data;
  }

  async departRooms(bookingId: ID, payload: DepartRoomsRequest): Promise<DeparturePreview> {
    const response = await post<ApiResponse<DeparturePreview>>(
      departureEndpoints.departRooms(bookingId),
      payload,
    );
    if (!response.data?.data) {
      throw new Error(response.data?.message || 'Check-out failed.');
    }
    return response.data.data;
  }
}

export const departureService = new DepartureService();
export default departureService;
